// src/shared/hooks/usePermissions.js
import { isAdminUser, getAuthData } from '../utils/auth';

export default function usePermissions() {
  const isAdmin   = isAdminUser();
  const authData  = getAuthData();
  const isSsoUser = authData?.auth_method === 'sso';

  return {
    canViewAllTickets:    isAdmin,
    canAssignTicket:      isAdmin,
    canViewAgentWorkload: isAdmin,
    canAccessSettings:    isAdmin,
    canChangePassword:    !isSsoUser,
  };
}
